(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/utils/selfservice.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/utils/selfservice.js');

'use strict';

svs.numbergames.game.utils.isSelfService = () => Boolean(svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') && svs.core.config.data.svsconfig.isSelfService);

 })(window);